<template>
    <div class="alert-bar" :class="[props.variant]">
        <div class="inner">
            <slot name="icon">
                <AlertIcon class="icon" v-if="!slots.icon"/>
            </slot>
            <slot name="message">
                <span> {{ props.message }}</span>
            </slot>
        </div>
        <slot name="additional">
        </slot>
    </div>
</template>

<script setup lang="ts">
import AlertIcon from '@/components/icons/AlertIcon.vue';
import { useSlots } from 'vue';

export type AlertBarVariant = 'info' | 'warning' | 'error' | 'success' | 'banner' | 'agent_description'


const props = defineProps<{
    message: string;
    variant: AlertBarVariant;
}>();

const slots = useSlots();

</script>


<style lang="scss" scoped>
.alert-bar {
    display: flex;
    width: 100%;
    padding: 16px;
    align-items: center;
    gap: 16px;

    border-radius: 4px;

    @media screen and (max-width: 768px) {
        width: 100%;
        padding: 16px 12px;
        gap: 12px;
    }

    .inner {
        display: flex;
        align-items: center;
        gap: 24px;
        flex: 1 0 0;
    }

    .icon {
        width: 32px;
        height: 32px;
        flex-shrink: 0;

        @media screen and (max-width: 768px) {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
        }
    }

    .message {
        flex: 1 0 0;
        color: var(--Text-Title, #151515);

        font-family: Saans;
        font-size: 14px;
        font-style: normal;
        font-weight: 380;
        line-height: 160%;
    }

    &.info {
        background: var(--Support-colors-Blue-5, #EDF2F7);
    }

    &.agent_description {
        background: var(--Orange-5, #FFFCFA);
    }

    &.warning {
        background: var(--Support-colors-Yellow-15, #ECE8D5);
    }

    &.error {
        background: var(--Support-colors-Red-15, #F1D9D9);
    }

    &.success {
        background: var(--Support-colors-Green-v2-Background, #D0ECD7);
    }

    &.banner {
        background: var(--Support-colors-Yellow-15, #ECE8D5);
        padding: 8px 80px;
        .inner {
            align-items: center;
            display: flex;
            gap: 12px;
            margin: 0 auto;
            align-self: flex-start;
            width: 100%;

            padding: 0px 16px;
            max-width: 1440px;

            color: var(--Text-Title, #151515);
            font-family: Saans;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 160%;
            flex: 1 0 0;
        }
    }
}

.icon {
    display: block;
    width: 24px;
    height: 24px;

    @media screen and (max-width: 768px) {
        width: 20px;
        height: 20px;
    }

    path {
        fill: var(--Text-Title, #151515);
    }

    &.info path {
        fill: var(--Support-colors-Blue-100, #2B6AFB);
    }

    &.warning path {
        fill: var(--Support-colors-Yellow-100, #FFC107);
    }

    &.error path {
        fill: var(--Support-colors-Red-100, #F44336);
    }

    &.success path {
        fill: var(--Support-colors-Green-v2-100, #4CAF50);
    }

    &.banner path {
        fill: var(--Support-colors-Yellow-100, #FFC107);
    }
}
</style>